export default "__VITE_ASSET__7e16444b__"